<template>
  <div class="">
    <FilePopup v-if="isFilePriview" v-bind:filedata="filePriviewData" @closePopup="closePopup"></FilePopup>
    <TopAppBar
        :leftBtnMethod="leftBtnMethod"
        :leftBtnMode="leftBtnMode"
        :rightBtnMethod="rightBtnMethod"
        :rightBtnMode="rightBtnMode"
        :title="title"
        :hideCategory="true"
        staticMode="true"
    >
    </TopAppBar>
    <div class="d-flex flex-column">
      <top-app-bar-drawer></top-app-bar-drawer>
      <main class="main-wrapper flex-grow-1 with-footer">
        <div class="t-headline13 t-color-headlineBlack pda-14 t-center font-m fix-header-title">{{ $t('1455') }}</div>
        <div class="divider"></div>
        <div v-if="!isFilePriview" class="container container--narrow pdt-50 pdb-50">
          <div class="">
            <label
                class="mdc-text-field text-field mdc-text-field--outlined  w-full input-tag-wrapper h-auto pdl-14 min-h-46">
              <i class="material-icons mdc-text-field__icon t-color-textfieldGuid">
                <img alt="" class="w-22" src="/images/addTag_icon.png">
              </i>
              <div class="d-flex pdt-10 pdl-40 pdr-8 pdb-8 flex-wrap align-items-center">
									<span v-for="(tag, i) in form.tags" :key="i"
                        class="input-tag t-color-contentBlue bg-contentBlueInactive pdl-8  b-radius4 t-body6 mgr-4 d-flex align-items-center">
										<span>{{ tag.name }}</span>
										<i class="p-5 cursor-pointer material-icons position-relative font-16 close-material-icon" tabindex="0" @click="removeTag(i)" @keypress="removeTag(i)">close</i>
									</span>
                <input
                    id="tagInput"
                    :placeholder="form.tags.length === 0 ? $t('1457') : ''"
                    class="mdc-text-field__input font-r custominput pdl-4 t-color-contentBlue t-body6  max-w-100 pdt-2 pdb-2"
                    type="text"
                    @keyup="searchTags($event)"
                />
              </div>
            </label>
          </div>
          <div class="pdl-14 pdt-4 pdr-16 mgb-16 t-body4 t-color-textfieldGuid t-line-h-22">{{ $t("1458") }}</div>
          <div v-if="tags && tags.length" class="pdb-14">
            <div class="container container--narrow">
              <ul class="mdc-list pdb-0 mgb--12 pdt-0">
					<span v-for="(tag, index) in tags" :key="index">
						<li class="mdc-list-item pdt-15 pdb-15 pdl-0"
                tabindex="0" @click="addTag(tag)" @keypress="addTag(tag)">
								<span class="mdc-list-item__ripple"></span>
								<span class="mdc-list-item__text t-body6 t-color-bodyGrayA font-r ">{{ tag && tag.name }}</span>
							</li>
							<li v-if="index !== tags.length - 1" :key="index+'sap'" class="mdc-list-divider" role="separator"></li>
					</span>
              </ul>
            </div>
          </div>
          <div class="divider"></div>
          <div class="messageBox mgt-16">
            <label id="textEl" ref="textEl"
                   :class="{'mdc-text-field--invalid' : form.contentValid && !form.contents.body}"
                   class="mdc-text-field mdc-text-field--outlined mdc-text-field--textarea w-full"
                   data-mdc-auto-init="MDCTextField">
							<span class="mdc-notched-outline">
								<span class="mdc-notched-outline__leading"></span>
								<span class="mdc-notched-outline__notch">
												<span id="my-label-id"
                              class="mdc-floating-label t-body6 font-r"> {{ $t('1460') }}</span>
								</span>
								<span class="mdc-notched-outline__trailing"></span>
							</span>
              <span class="mdc-text-field__resizer">
								<textarea
                    v-model="form.contents.body"
                    aria-labelledby="my-label-id"
                    :class="form.contentValid && !form.contents.body ? 't-color-textfieldError' : 't-color-headlineBlack'"
                    class="mdc-text-field__input t-body6 font-r pda-16 t-line-h-26 l-spacing2 mgt-0 mgb-0"
                    maxlength="5000"
                    cols="40"
                    rows="11"
                    @keyup="charCount()"
                ></textarea>
							</span>
            </label>
          </div>
          <div class="mdc-text-field-helper-line mgl-auto">
            <div class="mdc-text-field-character-counter">
              {{ totalcharacter }} / 5000
            </div>
          </div>
          <div class="mgt-16">
<!--            <vue-editor use-custom-image-handler @image-added="uploadEditorFile" @image-removed="removeEditorFile" :placeholder="$t('1460')" :editor-toolbar="customToolbar" v-model="form.contents.body" class="" />-->
          </div>
          <div class="d-flex flex-wrap">
            <div v-for="(img, i) in form.contents.files" :key="i" class="square-image attached-image-preview mgt-24 social-write-attached-video social-write-attachment-size">
              <img v-if="getType(img.contentType) === 'image'"
                   :alt="img.originalName"
                   :src="img.resourceUri"/>
              <VideoComponent
                  v-else
                  :record="img"
                  :videoSize="'medium'"
                  :fullSizeVideo="true"
                  @click="priviewFiel(img)" @keypress="priviewFiel(img)"
                  :size="'w-126 h-126'"
                  >
              </VideoComponent>
              <div tabindex="0" @click="priviewFiel(img)" @keypress="priviewFiel(img)"></div>
              <span class="remove-img remove-image-new position-absolute t-color-white"
                    tabindex="0" @click="form.contents.files.splice(i, 1)" @keypress="form.contents.files.splice(i, 1)">
									<i class="material-icons t-body1">close</i>
              </span>
            </div>

          </div>
        </div>
      </main>
      <div class="footer bottomStack bg-white">
        <div class="divider"></div>
        <div class="container container--narrow pdb-0">
          <photo-album :form="form" @removeImage="removeImage" @toggleDocument="toggleDocument"
                       @uploadFile="uploadContentsFile">
            <div slot="submitButton">
              <button :disabled="isDisabled"
                      class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText mgr-8 " tabindex="0"
                      @click="askForRegister" @keypress="askForRegister">
                <div class="mdc-button__ripple"></div>
                <span class="mdc-button__label t-body2 font-r">{{ $t('1456') }}</span>
              </button>
              <button class="mdc-button bg-white t-color-secondaryBtnText mgr--12" tabindex="0" @click="goBack" @keypress="goBack">
                <div class="mdc-button__ripple"></div>
                <span class="mdc-button__label t-body2 font-r">{{ $t('3322') }}</span>
              </button>
            </div>
          </photo-album>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {MDCTextField} from '@material/textfield'
import {MDCTopAppBar} from "@material/top-app-bar";
import socialApi from "@/api/socialApi.js";
import FilePopup from "./FilePopup";
import {MDCRipple} from '@material/ripple'

import {fileMixin} from "@/mixins/file";
import TopAppBarDrawer from "../TopAppBarDrawer.vue";
import {topAppBarMixin} from "../../mixins/topAppBar.js";
import TopAppBar from "../TopAppBar.vue";

import "video.js/dist/video-js.css";
import {videoPlayer} from "vue-video-player";
// import { VueEditor } from "vue2-editor";

import _ from 'lodash'
import VideoComponent from "@/components/common/VideoComponent.vue";
import snackMessage from "@/plugins/snackMessage";

export default {
  components: {
    videoPlayer,
    // VueEditor,
    TopAppBarDrawer,
    TopAppBar,
    FilePopup,
    VideoComponent,
    'photo-album': () => import('@/components/common/PhotoAlbum')
  },

  mixins: [topAppBarMixin, fileMixin],

  data() {
    return {
      form: {
        category: null,
        status: null,
        boardType: null,
        notifyType: null,
        contentValid: false,
        contents: {
          type: null,
          subject: null,
          body: '',
          linkName: null,
          linkUrl: null,
          files: [],
          editorImages: [],
          images: [],
          video: {
            chunkCount: 0,
            contentType: null,
            duration: 0,
            height: 0,
            id: null,
            name: null,
            originalName: null,
            resourceUri: null,
            size: 0,
            subFileResourceUri: [],
            width: 0
          },
        },
        fixed: false,
        tags: []
      },
      boardId: '',
      boardName: '',
      tags: [],
      title: localStorage.getItem('brandName'),
      uploadTypeImg: true,
      isDisabled: false,
      filePriviewData: [],
      isFilePriview: false,
      boardData: null,
      isDrawerOpen: false,
      imageSize: false,
      totalcharacter: 0
    };
  },

  beforeMount() {
    this.boardId = this.$route.query.board
    this.boardName = this.$route.query.boardName;
    this.setDetail();
    socialApi.boardAuth(this.boardId).then(response => {
      this.boardData = response.data.data;
      socialApi
          .fetchMember()
          .then(response => {
            this.mamberData = response.data.data;
            let myId = this.mamberData.responsibilityId
            if (this.boardData.authType.value === 'STORE') {
              this.selectedChild = this.boardData.authPermission[0];
            } else {
              this.selectedChild = this.boardData.authPermission.find(child => child.partId == myId);
            }
          }).catch(err => {});
    }).catch(err => {});
  },

  mounted() {
    this.boardName = this.$route.query.boardName;
    this.setTopAppBarBack(localStorage.getItem('brandName'))
    this.setMaterialUi()
    const textField = new MDCTextField(this.$refs.textEl);
  },

  methods: {
    goBack() {
      this.$router.go(-1);
    },

    goBackPreviousPage() {
      this.$router.push('/socialLearning/' + this.boardId + "?boardName=" + this.boardName);
    },

    setMaterialUi() {
      const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function (el) {
        let button = new MDCRipple.attachTo(el)
        return button
      })
      const textField = [].map.call(
          document.querySelectorAll(".mdc-text-field"),
          function (el) {
            return new MDCTextField.attachTo(el);
          }
      );
    },

    priviewFiel(file) {
      this.filePriviewData = file;
      this.isFilePriview = true;
    },

    charCount() {
      let char = this.form.contents.body.length;
      this.totalcharacter = char;
    },

    closePopup() {
      this.filePriviewData = Array();
      this.isFilePriview = false;
    },

    resetVideo() {
      this.form.contents.files = {
        id: null,
        name: null,
        contentType: null,
        originalName: null,
        resourceUri: null,
        width: 0,
        height: 0,
        duration: 0,
        chunkCount: 0,
        size: 0,
        subFileResourceUri: [],
        isUnzip: true
      };
    },

    videoAudioSelected() {
      if (
          (this.uploadTypeImg &&
              this.form.contents.files &&
              this.form.contents.files.resourceUri) ||
          (!this.uploadTypeImg && this.form.contents.files.length)
      ) {
        this.$alert({
          // title: this.$t('72'),
          content: this.$t("1473"),
          accept: this.$t("1476")
        });
        return false;
      }
      return true;
    },

    invalidVideoCount() {
      if (
          !this.uploadTypeImg &&
          this.form.contents.files &&
          this.form.contents.files.resourceUri
      ) {
        this.$alert({
          content: this.$t("1471"),
          accept: this.$t("1472")
        });
        return false;
      }
      return true;
    },

    register() {
      const isEdit = this.form.id;
      if (this.boardData.userBbsToDayAuth || isEdit) {
        this.$showLoading();

        let action = this.form.id
            ? socialApi.updatePost(this.form.id, this.form, this.boardId)
            : socialApi.register(this.form, this.boardId);
        action
            .then(response => {
              this.$hideLoading();
              this.isDisabled = true;
              this.$router.push('/socialLearning/' + this.boardId + '/' + response.data.data.id + '?boardName=' + encodeURI(this.boardName));
            })
            .catch(err => {
              this.$hideLoading();
              this.$error({content: err.errMsg}).then(() => {
              });
            });
      } else {
        this.$hideLoading();
        snackMessage(this.$t("3064"));
      }
    },

    setDetail() {
      if (!this.$route.params.postId) return;
      this.$showLoading();
      socialApi
          .socialDetails(this.$route.params.postId, this.boardId)
          .then(response => {
            Object.assign(this.form, response.data.data);
            if(this.form.contents.body !== '') {
              document.querySelector('.mdc-notched-outline').classList.add('mdc-notched-outline--upgraded', 'mdc-notched-outline--notched');
              document.querySelector('.mdc-floating-label').classList.add('mdc-floating-label--float-above');
            }
            this.$hideLoading();
          })
          .catch(err => {
            this.$error({content: err.errMsg}).then(() => {
            });
          });
    },

    askForRegister() {
      // check if No content exists
      if (!this.form.contents.body) {
        this.form.contentValid = true;
        return;
      } else if(this.form.contents.type) {
        // this.form.contents.type.value = 'HTML';
      }
      this.isDisabled = true;
      this.register();
    },
	
	  async searchTags(event) {
		  const tag = event.target.value.trim();
		  if (tag === '') {
			  this.tags = [];
			  return;
		  }
			
		  if (event.key === 'Enter') {
			  this.addTag(tag);
		  } else {
			  try {
				  const searchResult = await socialApi.searchTags(tag);
				  this.tags = searchResult.data.data;
			  } catch (err) {
				  this.$error({content: err});
			  }
		  }
	  },

    removeTag(index) {
      this.form.tags.splice(index, 1);
      this.tags = [];
    },

    closeDrawer() {
      this.isDrawerOpen = false;
    },
  }
};
</script>

<style scoped>
.post-img span {
  padding: 5px;
  /* border: 1px solidvar(--DocumentGray); */
  cursor: pointer;
  background: var(--Iconinactive);
}

.remove-image-new {
  top: -11px;
  right: -11px;
  border-radius: 50%;
  width: 21px;
  height: 21px;
  background: var(--Iconinactive);
  display: flex;
  justify-content: center;
  align-items: center;
  border: 4px solid var(--DocumentWhite);
  color: var(--DocumentWhite);
  line-height: 0px;

}

html[dir="rtl"] .remove-image-new {
  left: -11px;
}

.post-img {
  width: 100px;
  display: inline-block;
}

.post-img img {
  width: 100px;
}

.tag-ul {
  position: absolute;
  z-index: 1;
  margin-left: 20px;
  width: 97%;
}

html[dir="rtl"] .tag-ul {
  margin-right: 20px;
}

.tag-ul li {
  background-color: var(--DocumentGray);
  padding: 10px;
  border-bottom-color: var(--BodygrayA);
}

.p-5 {
  padding: 5px !important;
}

.cursor-pointer {
  cursor: pointer;
}

.no-border {
  border: none;
}
.input-tag {
    display: inline-flex;
    align-items: center;
    margin-bottom: 0px;
     margin-top: 0px;
}
.input-tag-wrapper i.close-material-icon{
  top: 1px !important;
  left: 0 !important;
}

.social-write-attachment-size {
  width: 126px !important;
  height: 126px !important;
}

</style>
